module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"parent_reviews":"이전 리뷰","more_reviews":{"true":"{0} 리뷰 펼쳐보기","false":"{0} 리뷰 접기"}}}')
  delete Component.options._Ctor
}
